import { useState, useEffect, useRef } from "react";
import "./AllOrder.css";
import "react-calendar/dist/Calendar.css";
import "./ReactCalendar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QuestionMark from "../../assets/icons/vector.svg";
import {
  Search,
  Calendar as CalendarIcon,
  Clock,
  CircleQuestionMark,
  ChevronRight,
  X,
} from "lucide-react";
import Calendar from "react-calendar";
import Select from "react-select";
import ApiService from "../../components/Api_services";
import {
  useNavigate,
  useLocation,
  Link,
  useSearchParams,
} from "react-router-dom";
import CancelOrder from "../../components/cancelorder_v2/CancelOrder";
import PaymentMethod from "../../components/paymentmethod_v2/PaymentMethod";
import MultiPurpose from "../../components/multipurpose_v2/MultiPurpose.js";
import CustomDropdown from "../../components/customdropdown_v2/CustomDropdown";
import Breadcrums from "../../components/breadcrums_v2/Breadcrums";
import { useSelector } from "react-redux";
import { hasAccess } from "../../utils/Permission";
import { ACCESS_KEYS } from "../../constants.js";
import FallbackImg from "../../components/FallbackImg.js";

function getPagination(current, total) {
  const pages = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    pages.push(1);
    if (current > 4) pages.push("...");
    let start, end;
    if (current <= 4) {
      start = 2;
      end = 5;
    } else if (current >= total - 3) {
      start = total - 4;
      end = total - 1;
    } else {
      start = current - 1;
      end = current + 1;
    }
    for (let i = start; i <= end; i++) {
      if (i > 1 && i < total) pages.push(i);
    }
    if (current < total - 3) pages.push("...");
    pages.push(total);
  }
  return pages;
}

const AllOrderv2 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  // Derive page, tab and type from URL
  const page = parseInt(searchParams.get("page") || "1", 10);
  const type = searchParams.get("type") || "all";
  const activeTab = type;
  const [showShippingPopup, setShowShippingPopup] = useState(
    () => !localStorage.getItem("hideShippingPopup"),
  );
  const [payingOrderNo, setPayingOrderNo] = useState(null);
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showReceivedNotif, setShowReceivedNotif] = useState(false);
  const [currentOrderNo, setCurrentOrderNo] = useState(null);
  const token = localStorage.getItem("access_token");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectedOrderPrices, setSelectedOrderPrices] = useState({});
  const [selectedOrderStatuses, setSelectedOrderStatuses] = useState({});
  const [footerTotalPrice, setFooterTotalPrice] = useState(null);
  const [showAllSelectedOrders, setShowAllSelectedOrders] = useState(false);
  const [totalOrders, setTotalOrders] = useState(0);
  const ordersPerPage = 5;
  const [showCancelOrderModal, setShowCancelOrderModal] = useState(false);
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [notice, setNotice] = useState({ show: false, message: "" });
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState(""); // This triggers API
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]); // [start, end]
  const [calendarTempRange, setCalendarTempRange] = useState([null, null]);
  const inputRef = useRef(null);
  const [countdowns, setCountdowns] = useState({});
  const [autoCancelledOrders, setAutoCancelledOrders] = useState({});
  const [statusCount, setStatusCount] = useState({});
  const [showFooterPaymentMethod, setShowFooterPaymentMethod] = useState(false);
  const [showFooterPopup, setShowFooterPopup] = useState(false);

  const sub_role = useSelector((state) => state.auth.sub_role) || [];
  const is_subuser =
    useSelector((state) => state.auth.user?.is_subuser) || false;
  // const sub_branch_id = useSelector((state) => state.auth.user?.sub_branch) || "";
  // const subBranchIds = Array.isArray(sub_branch_id)
  // ? sub_branch_id
  // : typeof sub_branch_id === "string" && sub_branch_id.includes(",")
  // ? sub_branch_id.split(",").map((id) => id.trim()).filter(Boolean)
  // : sub_branch_id
  // ? [sub_branch_id]
  // : [];
  //refresh tab notification number
  const [refreshKey, setRefreshKey] = useState(0);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleString("en-MY", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const canPayOrCancel =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_ORDER);

  const statusTypeMap = {
    all: "all",
    topay: "to_pay",
    neworder: "new",
    processing: "processing",
    toship: "shipping",
    toreceive: "to_receive",
    cancelled: "cancelled",
  };

  const [allBranchOptions, setAllBranchOptions] = useState([
    { value: "", label: "All Branch" },
  ]);

  const [selectedBranch, setSelectedBranch] = useState({
    value: "",
    label: "All Branch",
  });

  // Add this effect to sync defaults to URL
  useEffect(() => {
    const params = Object.fromEntries([...searchParams]);
    let changed = false;
    if (!params.page) {
      params.page = 1;
      changed = true;
    }
    if (!params.type) {
      params.type = "all";
      changed = true;
    }
    if (changed) {
      setSearchParams(params);
    }
  }, [searchParams, setSearchParams]);

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   let changed = false;
  //   if (!params.get("tab")) {
  //     params.set("tab", "cash");
  //     changed = true;
  //   }
  //   if (!params.get("type")) {
  //     params.set("type", "all");
  //     changed = true;
  //   }
  //   if (!params.get("page")) {
  //     params.set("page", "1");
  //     changed = true;
  //   }
  //   if (changed) {
  //     // Use replace to avoid adding to browser history
  //     navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  //   }
  // }, []);

  // 通用订单获取函数
  const fetchOrders = async (
    pageNum = 1,
    branch = selectedBranch,
    searchText = search,
    range = dateRange,
  ) => {
    setLoading(true);
    setError(null);
    try {
      let params = {
        page: pageNum,
        statusType: statusTypeMap[activeTab],
      };

      params.statusType = statusTypeMap[activeTab] || "all";
      if (searchText) {
        params.search = searchText;
        params.statusType = branch.value
          ? `search_branch_${statusTypeMap[activeTab]}`
          : `search_${statusTypeMap[activeTab]}`;
      } else if (branch.value) {
        params.branch_id = branch.value;
        params.statusType = `search_branch_${statusTypeMap[activeTab]}`;
      }

      // Add date range if both dates are selected
      if (range && range[0] && range[1]) {
        const pad = (n) => n.toString().padStart(2, "0");
        const formatLocalDate = (d) =>
          `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        params.start_date = formatLocalDate(range[0]);
        params.end_date = formatLocalDate(range[1]);
      }

      const response = await ApiService.getOrderList(params);

      if (Array.isArray(response.data)) {
        setOrderList(response.data);
        setTotalOrders(
          response.pagination?.total_records || response.data.length,
        );
      } else if (Array.isArray(response)) {
        setOrderList(response);
        setTotalOrders(response.length);
      } else {
        setOrderList([]);
        setTotalOrders(0);
        setError("No order data found.");
      }
    } catch (error) {
      setError("An error occurred while fetching orders.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Update countdowns every second
    const timer = setInterval(() => {
      setCountdowns((prev) => {
        const updated = {};
        orderList.forEach((order) => {
          updated[order.order_no] = getTimeLeft(order.expiry_date);
        });
        return updated;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [orderList]);

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    try {
      let data;
      // if (is_subuser && subBranchIds.length > 0) {
      //   // 只查 subuser 的所有分行
      //   data = await ApiService.getBranchList({ branch_id: subBranchIds });
      // } else {
      //   data = await ApiService.getBranchList();
      // }
      data = await ApiService.getBranchList();
      if (Array.isArray(data)) {
        const options = data.map((item) => ({
          value: item.branch_id,
          label: item.branch_code,
        }));
        setAllBranchOptions([{ value: "", label: "All Branch" }, ...options]);
        // 如果是 subuser，默认选中所有自己的分行
        // if (is_subuser && subBranchIds.length > 0) {
        //   // 只选第一个分行为默认
        //   setSelectedBranch(
        //     options.find((opt) => subBranchIds.includes(opt.value)) ||
        //       { value: subBranchIds[0], label: subBranchIds[0] }
        //   );
        // }
      }
    } catch (err) {
      console.error("Error fetching branch list:", err);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(searchInput);
    // Update URL to page 1
    const params = new URLSearchParams(location.search);
    params.set("page", 1);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const clearSearch = () => {
    setSearchInput("");
    setSearch("");
    const params = new URLSearchParams(location.search);
    params.set("page", 1);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    if (searchInput === "") {
      setSearch("");
    }
  }, [searchInput]);

  const handleOrderClick = (order, e) => {
    // Prevent default if order_no is missing
    if (!order.order_no) {
      e.preventDefault();
      console.error("Missing order_no for:", order);
      return;
    }

    // Optional: Log the navigation
    // console.log(`Navigating to order: ${order.order_no}`);
  };

  const handleBranchChange = (selectedOption) => {
    setSelectedBranch(selectedOption);
    // Update URL to page 1
    const params = new URLSearchParams(location.search);
    params.set("page", 1);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const handlePageChange = (newPage) => {
    setShowReceivedNotif(false);
    // Update the URL with the new page parameter
    const params = new URLSearchParams(location.search);
    params.set("page", newPage);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  const isSelectable = (order) => {
    return order.can_pay_now;
  };

  const handleSelect = async (orderNo) => {
    const newSelected = selectedOrders.includes(orderNo)
      ? selectedOrders.filter((no) => no !== orderNo)
      : [...selectedOrders, orderNo];

    setSelectedOrders(newSelected);

    if (newSelected.length === 0) {
      setFooterTotalPrice(null);
      setSelectedOrderPrices({});
      setSelectedOrderStatuses({});
      return;
    }

    try {
      const response = await ApiService.getOrderPriceSummary({
        so_ids: newSelected.join(","),
      });
      if (response && response.status === 200) {
        setFooterTotalPrice(response.data.total_price);
        if (Array.isArray(response.data.orders)) {
          const priceMap = {};
          const statusMap = {};
          response.data.orders.forEach((o) => {
            priceMap[o.so_id] = o.price;
            statusMap[o.so_id] = o.status;
          });
          setSelectedOrderPrices(priceMap);
          setSelectedOrderStatuses(statusMap);
        }
      }
    } catch (err) {
      console.error("Error fetching order price summary:", err);
      setFooterTotalPrice(null);
    }
  };

  const handleSelectAll = async () => {
    if (selectedOrders.length > 0) {
      setSelectedOrders([]);
      setFooterTotalPrice(null);
      setSelectedOrderPrices({});
      setSelectedOrderStatuses({});
      return;
    }
    try {
      const response = await ApiService.getOrderPriceSummary();
      if (response && response.status === 200) {
        const allOrderIds = response.data.orders.map((order) => order.so_id);
        setSelectedOrders(allOrderIds);
        setFooterTotalPrice(response.data.total_price);
        const priceMap = {};
        const statusMap = {};
        response.data.orders.forEach((o) => {
          priceMap[o.so_id] = o.price;
          statusMap[o.so_id] = o.status;
        });
        setSelectedOrderPrices(priceMap);
        setSelectedOrderStatuses(statusMap);
      }
    } catch (err) {
      console.error("Error fetching all order IDs:", err);
    }
  };

  const calculateTotal = () => {
    if (footerTotalPrice !== null) {
      return parseFloat(footerTotalPrice).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    return "";
  };

  // Handle cancelling selected orders
  const handleCancelSelectedOrders = () => {
    if (selectedOrders.length === 0) return;
    setShowCancelOrderModal(true);
  };

  const handleCancelSuccess = async () => {
    try {
      // Clear selection
      setSelectedOrders([]);
      setFooterTotalPrice(null);
      setSelectedOrderPrices({});
      // Refresh order counts in tabs
      setRefreshKey((prev) => prev + 1);

      // Redirect to Cash/To Pay tab if we're not already there
      if (type !== "topay") {
        navigate("/allorder?type=topay");
      } else {
        // Just refresh the current list if we're already on the right tab
        fetchOrders(1, selectedBranch, search);
      }
    } catch (error) {
      console.error("Error handling cancel success:", error);
    }
  };

  // Handler for range selection
  const handleDateRangeChange = (range) => {
    setDateRange(range);
    setCalendarOpen(false);
    // Optionally trigger fetchOrders here with range[0] and range[1]
  };

  function parseExpiryDate(expiryDateStr) {
    if (!expiryDateStr) return null;
    // Convert "2025-09-16 12 a.m." to "2025-09-16 00:00"
    let str = expiryDateStr.trim();

    // Handle "12 a.m." as 00:00 and "12 p.m." as 12:00
    const match = str.match(/^(\d{4}-\d{2}-\d{2}) (\d{1,2}) (a\.m\.|p\.m\.)$/i);
    if (match) {
      let [_, date, hour, period] = match;
      hour = parseInt(hour, 10);
      let hour24 = hour;
      if (period.toLowerCase() === "a.m.") {
        hour24 = hour === 12 ? 0 : hour;
      } else if (period.toLowerCase() === "p.m.") {
        hour24 = hour === 12 ? 12 : hour + 12;
      }
      str = `${date} ${hour24.toString().padStart(2, "0")}:00:00`;
    } else {
      // fallback: replace " a.m."/" p.m." with " AM"/" PM" for Date parsing
      str = str.replace(" a.m.", " AM").replace(" p.m.", " PM");
    }

    const date = new Date(str);
    if (isNaN(date.getTime())) return null;
    return date;
  }

  function getTimeLeft(expiryDate) {
    const expiry = parseExpiryDate(expiryDate);
    if (!expiry) return { h: "00", m: "00", s: "00", expired: true };
    const now = new Date();
    const diff = expiry - now;
    if (diff <= 0) return { h: "00", m: "00", s: "00", expired: true };
    const h = String(Math.floor(diff / 1000 / 60 / 60)).padStart(2, "0");
    const m = String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, "0");
    const s = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");
    return { h, m, s, expired: false };
  }

  // Auto-cancel function
  const handleAutoCancelOrder = async (orderNo) => {
    const order = orderList.find((o) => o.order_no === orderNo);
    if (
      !orderNo ||
      autoCancelledOrders[orderNo] ||
      !["To Pay", "To Pay - Failed"].includes(order.status_label)
    )
      return;

    try {
      const response = await ApiService.cancelOrders(orderNo);
      if (response && response.status) {
        setAutoCancelledOrders((prev) => ({ ...prev, [orderNo]: true }));
        setNotice({
          show: true,
          message: `Order ${orderNo} has expired and been automatically cancelled.`,
        });
        // Optionally refresh orders
        fetchOrders(page, selectedBranch, search, dateRange);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error auto-cancelling order:", error);
    }
  };

  // useEffect(() => {
  //   orderList.forEach((order) => {
  //     const countdown = countdowns[order.order_no];
  //     if (
  //       countdown?.expired &&
  //       !autoCancelledOrders[order.order_no] &&
  //       order.status_label === "To Pay"
  //     ) {
  //       handleAutoCancelOrder(order.order_no);
  //     }
  //   });
  // }, [countdowns, orderList]);

  useEffect(() => {
    setNotice({ show: false, message: "" }); // Reset notice
    setAutoCancelledOrders({}); // Reset cancelled orders tracking
    fetchOrders(page, selectedBranch, search, dateRange);
  }, [activeTab, page, selectedBranch, search, dateRange]);

  useEffect(() => {
    const fetchCounts = async () => {
      const data = await ApiService.getOrderStatusCount();
      setStatusCount(data);
    };
    fetchCounts();
  }, [refreshKey]);

  const handleTabChange = (tab) => {
    setSearchInput("");
    setSearch("");
    setDateRange(null);
    setCalendarTempRange([null, null]);
    setCalendarOpen(false);
    setSelectedOrders([]);
    setFooterTotalPrice(null);
    setSelectedOrderPrices({});
    setOrderList([]);
    const params = new URLSearchParams(searchParams);
    params.set("type", tab);
    params.set("page", "1");
    setSearchParams(params, { replace: true });
  };

  const FooterPopup = ({ onClose }) => {
    if (selectedOrders.length === 0) {
      return;
    }

    return (
      <div className="footerpopup_v2">
        <div className="footerpopup-content_v2">
          <div className="footerpopup-title-container_v2">
            <div className="footerpopup-title_v2">
              <strong>Selected Orders</strong>
            </div>
            <button className="fpclose-button_v2" onClick={onClose}>
              <X />
            </button>
          </div>

          <div className="footerpopup-main_v2">
            <div className="footerpopup-label_v2">
              You have selected <span>{selectedOrders.length} orders</span>.
            </div>

            <div className="footerpopup-total_v2">
              <div className="footerpopup-total-item_v2 first-item">
                <div>Orders Selected :</div>
                <div>{selectedOrders.length}</div>
              </div>

              <div className="footerpopup-total-item_v2">
                <div>Total Amount:</div>
                <div className="footerpopup-total-value_v2">
                  <div className="footerpopup-RM_v2">RM</div>
                  <div style={{ fontSize: "20px" }}>
                    {footerTotalPrice
                      ? formatCurrency(footerTotalPrice)
                      : "0.00"}
                  </div>
                </div>
              </div>
            </div>

            <div className="footerpopup-itemlist_v2">
              {selectedOrders.map((inv) => {
                const status = selectedOrderStatuses[inv];
                const price = selectedOrderPrices[inv] ?? null;
                return (
                  <div key={inv} className="footerpopup-item_v2">
                    {status && (
                      <div
                        className={`footerpopup-item-tag_v2 ${status.toLowerCase()}_v2`}
                      >
                        {status}
                      </div>
                    )}
                    <div className="footerpopup-item-inv_v2">{inv}</div>
                    <div className="footerpopup-item-dash_v2">-</div>
                    <div className="footerpopup-item-amt_v2">
                      <div>RM</div>
                      {price != null ? formatCurrency(price) : "0.00"}
                    </div>
                    <div
                      className="footerpopup-item-clear_v2"
                      onClick={() => handleSelect(inv)}
                      style={{ cursor: "pointer" }}
                      title="Unselect"
                    >
                      <X size={16} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="footerpopup-sub_v2">
            <button
              className="fp-cancel_v2"
              onClick={() => {
                setSelectedOrders([]);
                setSelectedOrderPrices({});
                setSelectedOrderStatuses({});
                setFooterTotalPrice(0);
                onClose();
              }}
            >
              Clear All
            </button>

            <button className="fp-ok_v2" onClick={onClose}>
              Done
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="allorder_v2">
      <Breadcrums />
      <div className="allorder-content_v2">
        {notice.show && (
          <MultiPurpose
            title="Notice"
            message={notice.message}
            yesText="OK"
            showYesLink={false}
            hideNo={true}
            onYes={() => setNotice({ show: false, message: "" })}
            onNo={() => setNotice({ show: false, message: "" })}
            onClose={() => setNotice({ show: false, message: "" })}
          />
        )}

        <div className="myorder-title-container_v2">
          <div className="myorder-title_v2">
            <strong>MY ORDERS</strong>
          </div>
        </div>

        {canPayOrCancel ? (
          <>
            <div className="allorder-container_v2">
              <div className="allorder-main_v2">
                {/* MyOrder Top Navigation Bar */}
                <div className="myordernav_v2">
                  <div
                    className={`myordertab_v2${type === "all" ? " active-tab_v2" : ""}`}
                    onClick={() => handleTabChange("all")}
                  >
                    All
                  </div>

                  <div
                    className={`myordertab_v2${type === "neworder" ? " active-tab_v2" : ""}`}
                    onClick={() => handleTabChange("neworder")}
                  >
                    New
                    {statusCount.new > 0 && (
                      <div className="unread_v2">({statusCount.new})</div>
                    )}
                  </div>

                  <div
                    className={`myordertab_v2${
                      type === "processing" ? " active-tab_v2" : ""
                    }`}
                    onClick={() => handleTabChange("processing")}
                  >
                    Processing
                    {statusCount.processing > 0 && (
                      <div className="unread_v2">
                        ({statusCount.processing})
                      </div>
                    )}
                  </div>

                  <div
                    className={`myordertab_v2${type === "toship" ? " active-tab_v2" : ""}`}
                    onClick={() => handleTabChange("toship")}
                  >
                    Shipping
                    {statusCount.shipping > 0 && (
                      <div className="unread_v2">({statusCount.shipping})</div>
                    )}
                  </div>

                  <div
                    className={`myordertab_v2${type === "toreceive" ? " active-tab_v2" : ""}`}
                    onClick={() => handleTabChange("toreceive")}
                  >
                    Completed
                  </div>

                  <div
                    className={`myordertab_v2${type === "cancelled" ? " active-tab_v2" : ""}`}
                    onClick={() => handleTabChange("cancelled")}
                  >
                    Cancelled
                  </div>
                </div>

                <div className="allorder-sub_v2">
                  {(activeTab === "all" || activeTab === "neworder") && (
                    <label className="selectall_v2">
                      <input
                        type="checkbox"
                        checked={
                          selectedOrders.length > 0 && footerTotalPrice !== null
                        }
                        onChange={handleSelectAll}
                      />
                      <div>Select All ({selectedOrders.length || 0})</div>
                    </label>
                  )}

                  <div className="allorder-actions_v2">
                    <form
                      onSubmit={handleSearch}
                      className="searchbar-allorder_v2"
                    >
                      <Search size={16} />
                      <input
                        placeholder="Search by order no., item code or product name..."
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        onBlur={(e) => {
                          setSearchInput(e.target.value);
                          handleSearch(e);
                        }}
                      />
                      <div
                        className="searchbar-allorder-remove_v2"
                        style={{
                          visibility: searchInput ? "visible" : "hidden",
                          pointerEvents: searchInput ? "auto" : "none",
                        }}
                        onClick={clearSearch}
                      >
                        &#x2715;
                      </div>
                    </form>

                    {/* Date Picker */}
                    {/* <form
                      className="ao-date-picker-container_v2"
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (calendarTempRange?.[0] && calendarTempRange?.[1]) {
                          handleDateRangeChange(calendarTempRange);
                        }
                      }}
                    >
                      <CalendarIcon
                        size={16}
                        onClick={() => setCalendarOpen((open) => !open)}
                      />
                      <input
                        ref={inputRef}
                        type="text"
                        className="ao-date-range-input_v2"
                        value={
                          calendarTempRange?.[0]
                            ? `${new Date(
                                calendarTempRange[0],
                              ).toLocaleDateString("en-MY", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })} - ${
                                calendarTempRange[1]
                                  ? new Date(
                                      calendarTempRange[1],
                                    ).toLocaleDateString("en-MY", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })
                                  : "End Date"
                              }`
                            : "Select Date Range"
                        }
                        onClick={() => setCalendarOpen((open) => !open)}
                        readOnly
                      />
                      {(calendarTempRange?.[0] || calendarTempRange?.[1]) && (
                        <div
                          className="ao-date-picker-remove"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCalendarTempRange([null, null]);
                            setDateRange([null, null]);
                            setCalendarOpen(false);
                          }}
                        >
                          &#x2715;
                        </div>
                      )}
                      {calendarOpen && (
                        <div className="allorder-calendar_v2">
                          <Calendar
                            selectRange
                            onChange={(range) => {
                              setCalendarTempRange(range);
                              // Focus input after two dates are picked
                              if (
                                range?.[0] &&
                                range?.[1] &&
                                inputRef.current
                              ) {
                                inputRef.current.focus();
                              }
                              setCalendarOpen(false);
                            }}
                            value={calendarTempRange}
                            maxDate={new Date()}
                          />
                        </div>
                      )} */}
                    {/* Hidden submit button to allow Enter key to trigger onSubmit */}
                    {/* <button
                        type="submit"
                        style={{ display: "none" }}
                        tabIndex={-1}
                      ></button>
                    </form> */}
                    <div className="ao-date-picker-container_v2">
                      <CalendarIcon
                        size={16}
                        onClick={() => setCalendarOpen((open) => !open)}
                      />
                      <input
                        ref={inputRef}
                        type="text"
                        className="ao-date-range-input_v2"
                        value={
                          calendarTempRange?.[0]
                            ? `${new Date(
                                calendarTempRange[0],
                              ).toLocaleDateString("en-MY", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })} - ${
                                calendarTempRange[1]
                                  ? new Date(
                                      calendarTempRange[1],
                                    ).toLocaleDateString("en-MY", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })
                                  : "End Date"
                              }`
                            : "Select Date Range"
                        }
                        onClick={() => setCalendarOpen((open) => !open)}
                        readOnly
                      />
                      {(calendarTempRange?.[0] || calendarTempRange?.[1]) && (
                        <div
                          className="ao-date-picker-remove"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCalendarTempRange([null, null]);
                            setDateRange([null, null]);
                            setCalendarOpen(false);
                          }}
                        >
                          &#x2715;
                        </div>
                      )}
                      {calendarOpen && (
                        <div className="allorder-calendar_v2">
                          <Calendar
                            selectRange
                            onChange={(range) => {
                              setCalendarTempRange(range);
                              if (range?.[0] && range?.[1]) {
                                handleDateRangeChange(range);
                              }
                              setCalendarOpen(false);
                            }}
                            value={calendarTempRange}
                            maxDate={new Date()}
                          />
                        </div>
                      )}
                    </div>

                    <CustomDropdown
                      options={allBranchOptions}
                      value={selectedBranch.value}
                      onChange={(val, opt) => handleBranchChange(opt)}
                      placeholder="All Branch"
                      className="allorder-dropdown_v2"
                      hideSearchbar={true}
                    />
                  </div>
                </div>

                <div className="allorder-sub2_v2">
                  {orderList.length === 0 && loading ? (
                    <p>Loading orders...</p>
                  ) : error ? (
                    <p style={{ color: "red" }}>{error}</p>
                  ) : orderList.length === 0 ? (
                    <p>No orders found.</p>
                  ) : (
                    orderList.map((order, index) => (
                      <div key={order.order_no || index}>
                        <Link
                          to={`/orderdetail/${order.order_no}?type=${type}${
                            order.can_pay_now ? "&canpay" : "&cannotpay"
                          }`}
                          onClick={(e) => handleOrderClick(order, e)}
                          className={`allorder-item_v2${selectedOrders.includes(order.order_no) ? " active" : ""}`}
                        >
                          <div className="aoitem-main_v2">
                            {/* Checkbox */}
                            {isSelectable(order) ? (
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(
                                  order.order_no,
                                )}
                                onChange={() =>
                                  canPayOrCancel && handleSelect(order.order_no)
                                }
                                onClick={(e) => e.stopPropagation()}
                                disabled={!canPayOrCancel}
                                style={{
                                  cursor: canPayOrCancel
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                title={canPayOrCancel ? "" : "No permission"}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "24px",
                                  display: "inline-block",
                                }}
                              ></div>
                            )}

                            <div className="aoitem-maincenter_v2">
                              {/* Status Tag */}
                              <div
                                className={`aoitem-tag_v2 ${
                                  order.status_label
                                    ? order.status_label
                                        .toLowerCase()
                                        .replace(/\s/g, "") + "_v2"
                                    : ""
                                }`}
                              >
                                {order.status_label === "To Pay" ||
                                order.status_label === "To Pay - Processing" ||
                                order.status_label === "To Pay - Failed"
                                  ? order.payment_status === "to_pay_pending"
                                    ? "Pending"
                                    : order.payment_status ===
                                        "to_pay_unsuccessful"
                                      ? "Unsuccessful"
                                      : "To Pay"
                                  : order.status_label === "Received"
                                    ? "Completed"
                                    : order.status_label}
                              </div>

                              {/* Reminders */}
                              {["To Pay", "To Pay - Failed"].includes(
                                order.status_label,
                              ) && (
                                <div className="ao-orderclose_v2">
                                  <Clock size={16} />
                                  <div>Order closes in</div>
                                  {countdowns[order.order_no]?.expired ? (
                                    <div>Expired</div>
                                  ) : (
                                    <>
                                      <div className="ao-orderclose-time_v2">
                                        {countdowns[order.order_no]?.h || "00"}
                                      </div>
                                      <div>:</div>
                                      <div className="ao-orderclose-time_v2">
                                        {countdowns[order.order_no]?.m || "00"}
                                      </div>
                                      <div>:</div>
                                      <div className="ao-orderclose-time_v2">
                                        {countdowns[order.order_no]?.s || "00"}
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}

                              {activeTab === "toship" && (
                                <div className="aoitem-received-reminder_v2">
                                  <span className="aoitem-received-info_v2">
                                    Status changes to{" "}
                                    <span className="aoitem-received-info-highlight_v2">
                                      <b>Received</b>
                                    </span>{" "}
                                    after set days
                                  </span>
                                  <div className="ao-quesmark-tooltip-container_v2">
                                    <CircleQuestionMark size={16} />
                                    <div className="ao-quesmark-tooltip-text_v2">
                                      <table>
                                        <tr>
                                          <td>Kuala Lumpur and Selangor</td>
                                          <td>:</td>
                                          <td>7 working days</td>
                                        </tr>
                                        <tr>
                                          <td>Other States</td>
                                          <td>:</td>
                                          <td>14 working days</td>
                                        </tr>
                                        <tr>
                                          <td>East Malaysia</td>
                                          <td>:</td>
                                          <td>45 working days</td>
                                        </tr>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Buttons */}
                            {order.can_pay_now &&
                              (order.payment_status === "to_pay" ||
                                order.payment_status ===
                                  "to_pay_unsuccessful") && (
                                <button
                                  className="aoitem-button_v2"
                                  onClick={(e) => {
                                    if (!canPayOrCancel) {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      return;
                                    }
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setPayingOrderNo(order.order_no);
                                    setShowPaymentMethod(true);
                                  }}
                                  disabled={!canPayOrCancel}
                                  style={{
                                    opacity: canPayOrCancel ? 1 : 0.5,
                                    cursor: canPayOrCancel
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                  title={canPayOrCancel ? "" : "No permission"}
                                >
                                  PAY NOW
                                </button>
                              )}
                            {order.status_label === "Shipping" && (
                              <button
                                className="aoitem-button_v2 toreceive"
                                onClick={(e) => {
                                  if (!canPayOrCancel) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setCurrentOrderNo(order.order_no);
                                  setShowReceivedNotif(true);
                                }}
                                disabled={!canPayOrCancel}
                                style={{
                                  opacity: canPayOrCancel ? 1 : 0.5,
                                  cursor: canPayOrCancel
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                title={canPayOrCancel ? "" : "No permission"}
                              >
                                RECEIVED
                              </button>
                            )}

                            {/* Icon */}
                            <div className="ao-nextsign_v2">
                              <ChevronRight size={24} />
                            </div>
                          </div>

                          <div className="aoitem-sub_v2">
                            <div className="aoitem-left_v2">
                              <div className="aoitem-orderno_v2">
                                <span className="aoitem-subtitle_v2">
                                  Order No.
                                </span>
                                <div className="aoitem-colon_v2">:</div>
                                <div className="aoitem-value_v2">
                                  {order.order_no ? order.order_no : "-"}
                                </div>
                              </div>
                              <div className="aoitem-date_v2">
                                <span className="aoitem-subtitle_v2">
                                  Order Date
                                </span>
                                <div className="aoitem-colon_v2">:</div>
                                <div className="aoitem-value_v2">
                                  {order.created_date
                                    ? formatDate(order.created_date)
                                    : "-"}
                                </div>
                              </div>
                            </div>
                            <div className="aoitem-right_v2">
                              <div className="aoitem-total_v2">
                                <span className="aoitem-subtitle_v2">
                                  Order Amount
                                </span>
                                <div className="aoitem-colon_v2">:</div>
                                <div className="aoitem-value-total_v2">
                                  RM{" "}
                                  {order.total_price
                                    ? formatCurrency(order.total_price)
                                    : "0.00"}
                                </div>
                              </div>
                              <div className="aoitem-delivery_v2">
                                <span className="aoitem-subtitle_v2">
                                  Delivery To{" "}
                                </span>
                                <div className="aoitem-colon_v2">:</div>
                                <div className="aoitem-value_v2">
                                  {Array.isArray(order.delivery) &&
                                  order.delivery.length > 0
                                    ? order.delivery.length === 1
                                      ? "1 branch"
                                      : `${order.delivery.length} branches`
                                    : "-"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))
                  )}
                  <div className="pagination-modern_v2">
                    <button
                      className="pagination-btn_v2"
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 1}
                    >
                      <span className="prevnext-text_v2">Previous</span>
                    </button>
                    {getPagination(
                      page,
                      Math.ceil(totalOrders / ordersPerPage),
                    ).map((p, idx) =>
                      p === "..." ? (
                        <span
                          key={`ellipsis-${idx}`}
                          className="pagination-ellipsis_v2"
                        >
                          ...
                        </span>
                      ) : (
                        <button
                          key={`page-${p}-${idx}`}
                          className={`pagination-btn_v2${
                            page === p ? " pagination-current_v2" : ""
                          }`}
                          onClick={() => handlePageChange(p)}
                          disabled={page === p}
                        >
                          {p}
                        </button>
                      ),
                    )}
                    <button
                      className="pagination-btn_v2"
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page === Math.ceil(totalOrders / ordersPerPage)}
                    >
                      <span className="prevnext-text_v2">Next</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="allorder-container_v2">
            <span style={{ color: "#b71c1c", fontWeight: 600 }}>
              You do not have permission to view My Order.
            </span>
          </div>
        )}
      </div>

      {selectedOrders.length > 0 && (
        <div className="orders-footer_v2">
          <div className="orders-footer-content_v2">
            <div className="selected-section-container_v2">
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div className="selected-section_v2">
                  SELECTED ORDERS ({selectedOrders.length})
                  {selectedOrders.length > 0 && (
                    <span
                      className="clearall-btn_v2"
                      onClick={() => {
                        setSelectedOrders([]);
                        setFooterTotalPrice(null);
                        setSelectedOrderPrices({});
                      }}
                    >
                      Clear All
                    </span>
                  )}
                </div>
                <div className="selected-id_v2">
                  {selectedOrders && selectedOrders.length > 0 && (
                    <>
                      {(showAllSelectedOrders
                        ? selectedOrders
                        : selectedOrders.slice(0, 3)
                      ).map((so) => {
                        const price = selectedOrderPrices[so];
                        return (
                          <div
                            key={so}
                            className="selected-order-pill_v2"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="selected-order-pill-info_v2">
                              <span className="selected-order-pill-no_v2">
                                {so}
                              </span>
                              <span className="selected-order-pill-amount_v2">
                                RM{" "}
                                {price != null ? formatCurrency(price) : "0.00"}
                              </span>
                            </div>
                            <span
                              className="selected-order-pill-remove_v2"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSelect(so);
                              }}
                              title="Unselect"
                            >
                              <X size={12} />
                            </span>
                          </div>
                        );
                      })}

                      {selectedOrders.length > 3 && (
                        <button
                          type="button"
                          className="selected-toggle_v2"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowFooterPopup(true);
                          }}
                        >
                          {`+${selectedOrders.length - 3} more`}
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "24px" }}
              >
                <div className="payment-section_v2">
                  TOTAL PAYMENT
                  <div className="payment-section-total_v2">
                    <div className="orders-footer-RM_v2">RM</div>
                    {calculateTotal()}
                  </div>
                </div>

                <div className="actions-section_v2">
                  <button
                    className="aoitem-button_v2 cancel"
                    onClick={handleCancelSelectedOrders}
                    style={{ width: "167px" }}
                  >
                    Cancel Order
                  </button>
                  <button
                    className="aoitem-button_v2"
                    onClick={setShowFooterPaymentMethod}
                    style={{ width: "167px" }}
                  >
                    Pay Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showFooterPopup && (
        <FooterPopup onClose={() => setShowFooterPopup(false)} />
      )}
      {showFooterPaymentMethod && (
        <PaymentMethod
          onClose={() => setShowFooterPaymentMethod(false)}
          onSelect={(method) => {
            setSelectedPaymentMethod(method);
            setShowFooterPaymentMethod(false);

            if (selectedOrders) {
              const orderIds = selectedOrders.join(",");
              let paymentType = "";
              if (method === "Online Banking") {
                paymentType = "online_banking";
              } else if (method === "FPX") {
                paymentType = "fpx";
              }

              navigate(`/uploadcheque?orders=${orderIds}&type=${paymentType}`);
            }
          }}
          orderNum={selectedOrders.length}
          orderId={selectedOrders.join(",")}
          totalAmount={calculateTotal()}
        />
      )}
      {showCancelOrderModal && (
        <CancelOrder
          orderId={selectedOrders} // Pass all selected orders
          onClose={() => setShowCancelOrderModal(false)}
          onSuccess={handleCancelSuccess}
          orderNo={selectedOrders.length}
        />
      )}
      {showPaymentMethod && (
        <PaymentMethod
          onClose={() => {
            setShowPaymentMethod(false);
            setPayingOrderNo(null); // Clear the paying order when modal is closed
          }}
          onSelect={(method) => {
            setSelectedPaymentMethod(method);
            setShowPaymentMethod(false);

            if (payingOrderNo) {
              let paymentType = "";
              if (method === "Online Banking") {
                paymentType = "online_banking";
              } else if (method === "FPX") {
                paymentType = "fpx";
              }

              navigate(
                `/uploadcheque?orders=${payingOrderNo}&type=${paymentType}`,
              );

              setPayingOrderNo(null);
            }
          }}
          orderNum={1}
          orderId={payingOrderNo}
          totalAmount={
            orderList.find((order) => order.order_no === payingOrderNo)
              ?.total_price
          }
        />
      )}
      {showReceivedNotif && (
        <MultiPurpose
          title="Confirm Order Receipt"
          useHTML={true}
          message={`Are you sure you want to confirm receipt of this order?<br /><span style="color: #1e5bc6; font-weight: 600;">Order No: ${currentOrderNo}</span>`}
          yesText="Confirm Receipt"
          noText="Cancel"
          onNo={() => setShowReceivedNotif(false)}
          onYes={async () => {
            if (currentOrderNo) {
              await ApiService.confirmReceive(currentOrderNo);
              setShowReceivedNotif(false);
              setCurrentOrderNo(null);
              fetchOrders(page, selectedBranch, search);
              setRefreshKey((k) => k + 1);
            }
          }}
          onClose={() => setShowReceivedNotif(false)}
          variant="success"
          className="received"
        />
      )}
    </div>
  );
};

export default AllOrderv2;
